module.exports=function(scope){ return `<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "No entry found in the database for this enrollmentIdentifier.",
        "subCode": "facemapNotFound"
    }
}

<!-- Invalid enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "One of the enrollmentIdentifier values was invalid. An enrollmentIdentifier must be a non-empty alphanumeric string. Underscores, hyphens, and emails are also allowed.",
        "subCode": "invalidName"
    }
}

<!-- NOTE: FaceTec Testing API does not return enrollmentIdnetifier in data object whereas the Server REST "provides data as additional properties" -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/failure/enrollment-get-facemap.json.tpl